import { TreatmentPricesCard } from "@/services/backend/vbs/pricing/components/treatment-prices-card";
import { ExtrasCard } from "@/services/backend/vbs/pricing/components/extras-card";

export function PricingCards({
  pricingId,
  disabled = false,
  showPostExecutionReduction = false,
}: {
  pricingId: string;
  disabled?: boolean;
  showPostExecutionReduction?: boolean;
}) {
  return (
    <div className="grid gap-2">
      <TreatmentPricesCard
        pricingId={pricingId}
        disabled={disabled}
        showPostExecutionReduction={showPostExecutionReduction}
      />
      <ExtrasCard disabled={disabled} pricingId={pricingId} />
    </div>
  );
}
